import { render, staticRenderFns } from "./ApuracaoAcaoDetalhesResumo.vue?vue&type=template&id=ba02b560&lang=html&"
import script from "./ApuracaoAcaoDetalhesResumo.vue?vue&type=script&lang=js&"
export * from "./ApuracaoAcaoDetalhesResumo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VChip,VSpacer})
